module.exports = __webpack_public_path__ + "static/media/Admin-4.e9e2d70b.png";